import { BrowserWindowFactory } from '../../module/browser/window.factory';
import { WindowServiceInterface } from './service.interface';

const browserWindowService = BrowserWindowFactory();

export function WindowService(): WindowServiceInterface {
  return browserWindowService;
}
